export const CHIAVI_CONTESTO_VALIDAZIONE = {
  // Persona
  OBBLIGO_CODICE_FISCALE: 'obbligoCodiceFiscale',
  OBBLIGO_NASCITA: 'obbligoNascita',
  OBBLIGO_DOCUMENTO: 'obbligoDocumento',
  OBBLIGO_RESIDENZA: 'obbligoResidenza',

  // Luogo
  WARNING_COORDINATE_PRIMO_INDIRIZZO: 'warning_coordinate_primo_indirizzo',
}